import { apiSlice } from "./apiSlice";
import { SubjectEntity } from "../../services/subjects/subjects.types";

/**
 * Subjects are a small full-list catalog (no server-side pagination), so a
 * single list query is enough; the table behaves client-side as before.
 */
export const subjectsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSubjects: builder.query<SubjectEntity[], void>({
      query: () => ({
        url: "/subjects",
        method: "GET",
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: "Subject" as const, id })),
              { type: "Subject" as const, id: "LIST" },
            ]
          : [{ type: "Subject" as const, id: "LIST" }],
    }),
    deleteSubject: builder.mutation<void, number>({
      query: (id) => ({
        url: `/subjects/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Subject", id: "LIST" }],
    }),
  }),
});

export const { useGetSubjectsQuery, useDeleteSubjectMutation } = subjectsApi;
